import React from 'react';
import {
  DateRangeSelector,
  Dropdown,
  DropdownItem,
  DropdownList,
  ENUM_DATE_RANGE,
  Input,
  Paginate
} from '@cokitchen/cokitchen-components';
import { FilterAltIcon } from 'cokitchen-icons';
import { ENUM_RETURNS_STATUS } from 'models/common.model';
import { FilterType } from '.';

export type ExtendedReturnsType = ENUM_RETURNS_STATUS;

type Props = {
  filters: FilterType;
  setFilters: (arg0: FilterType) => void;
  setCurrentPage: (value: number) => void;
  lastPage: number;
};
const ExcessReturnsFilter = ({ filters, setFilters, lastPage, setCurrentPage }: Props) => {
  const STATUS_LIST: { text: string; value: ExtendedReturnsType }[] = [
    {
      text: ENUM_RETURNS_STATUS.CREATED,
      value: ENUM_RETURNS_STATUS.CREATED
    },
    {
      text: ENUM_RETURNS_STATUS.COMPLETED,
      value: ENUM_RETURNS_STATUS.COMPLETED
    }
  ];

  const handleFilter = (filter: ExtendedReturnsType) => {
    setFilters({ ...filters, status: filter });
  };
  return (
    <div className='flex items-center gap-4 flex-wrap'>
      <div className='flex gap-3 items-center grow'>
        <Dropdown
          hideArrow
          placement='bottom-start'
          content={
            <div className='border border-[#E5E6E6] rounded-[5px] text-xs leading-[19px] h-[36px] flex px-2 justify-between items-center w-[114px]  cursor-pointer'>
              <span className='text-[#5E6164] text-sm'>Filter by</span>
              <FilterAltIcon className={`${filters.status ? 'text-red-5' : 'text-[#5E6164]'}`} />
            </div>
          }>
          <DropdownList>
            {STATUS_LIST.map(({ text, value }, i) => (
              <DropdownItem
                className={`capitalize ${filters.status === value ? 'text-red-5' : ''}`}
                key={i}
                onClick={() => handleFilter(value)}>
                {text} returns
              </DropdownItem>
            ))}
          </DropdownList>
        </Dropdown>

        <DateRangeSelector
          defaultRange={ENUM_DATE_RANGE.ALL}
          onChange={(v) => setFilters({ ...filters, dateRange: v.date })}
          className='text-[#5E6164] h-[36px] text-sm border-[#E5E6E6]'
          isInput
        />
      </div>

      <Input
        type='search'
        className='w-[280px]'
        inputClass='h-[30px]'
        placeholder='Search by code'
        value={filters.search}
        onChange={(e) => setFilters({ ...filters, search: e.target.value.toLocaleLowerCase() })}
      />
      <Paginate
        pageCount={lastPage}
        pageRangeDisplayed={2}
        onPageChange={(value) => setCurrentPage(value.selected + 1)}
      />
    </div>
  );
};

export default ExcessReturnsFilter;
